import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ClientInterface } from '../data';
import { ContractService } from '../services/contract.service';
import { Transaction } from '../transaction/transaction';
import { UseCase } from './common/use.case';

@Injectable()
export class GetAppropriatenessClientUseCase implements UseCase<Observable<Transaction<ClientInterface>>> {
    constructor(private contractService: ContractService) {}

    bind(): Observable<Transaction<ClientInterface>> {
        return this.contractService.getAppropriatenessClient();
    }
}
